import Vue from 'vue'

export const EDIT_QUOTE = (state, newQuote) => {
  let index = state.quotes.indexOf(state.activeQuote)
  if (index >= 0) {
    Vue.set(state.quotes, index, newQuote)
  }
  state.activeQuote = {}
}

export const ADD_QUOTE = (state, newQuote) => {
  let newList = Array.concat(state.quotes)

  newList.unshift(newQuote)
  state.quotes = newList
  state.activeQuote = {}
}

export const DELETE_QUOTE = (state, quote) => {
  let index = state.quotes.indexOf(quote)
  if (index >= 0) {
    state.quotes.splice(index, 1)
  }
}

export const SET_VOTE = (state, { quote, ranking, vote }) => {
  let index = state.quotes.indexOf(quote)
  if (index >= 0) {
    Vue.set(state.quotes, index, {
      ...quote,
      ranking: ranking,
      myVote: vote
    })
  }
}

export const FILTER_QUOTES = (state, data) => {
  state.quotes = data.quotes
  Vue.set(state.pager, 'after', data.pager.after)
}

export const MORE_QUOTES = (state, data) => {
  state.quotes = state.quotes.concat(data.quotes)
  Vue.set(state.pager, 'after', data.pager.after)
}

export const SET_ACTIVE_QUOTE = (state, quote) => {
  state.activeQuote = quote
}

export const SET_CHANGE_QUOTES = (state, data) => {
  state.changeQuotes = data
}

export const ME = (state, me) => {
  state.me = me
}

export const KALEIDERS = (state, kaleiders) => {
  state.authors = kaleiders.map(item => ({
    id: item.node.id,
    name: item.node.name || item.node.email
  }))

  state.authors.sort((a, b) => a.name.localeCompare(b.name))
}

export const FILTER_VISIBILITY = (state) => {
  state.filterVisibility = !state.filterVisibility
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js